import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

interface MonthlyPropertyCount {
  date: string; // Adjust the type to match your data for real estate
  propertyType: string; // Adjust the type to match your data for real estate
}

interface BarChartProps {
  monthlyPropertyCounts: MonthlyPropertyCount[];
}

interface BarChartProps {
  data: any;
  options: any;
}

interface BarChartProps {
  data: any;
  options: any;
}

export const BarChart: React.FC<BarChartProps> = ({ data, options }) => {
  const chartRef = useRef<HTMLCanvasElement | null>(null);
  const chartInstanceRef = useRef<Chart | null>(null);

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.getContext("2d");
      if (ctx) {
        if (chartInstanceRef.current) {
          chartInstanceRef.current.destroy();
        }
        chartInstanceRef.current = new Chart(ctx, {
          type: "bar",
          data,
          options,
        });
      }
    }

    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, [data, options]);

  return <canvas ref={chartRef} />;
};
